import React from 'react';
import { SidebarMenuItem, SidebarMenuButton } from 'src/shared/components/ui/sidebar';
import { useAppSelector } from 'src/store';
import { getAppRoutesAvailability, getSamplesRoutesAvailability } from 'src/routes/state/routesSelector';
import { useLocation } from 'react-router-dom';
import { samplesRouteSettings } from 'src/app/samples/Samples';
import useAppNavigation from 'src/shared/hooks/useAppNavigation';
import { PackageOpenIcon } from 'lucide-react';

const SampleReceptionMenu = () => {
    const appRoutesAvailability = useAppSelector(getAppRoutesAvailability);
    const samplesRoutesAvailability = useAppSelector(getSamplesRoutesAvailability);
    const navigate = useAppNavigation();
    const { pathname } = useLocation();

    if (!appRoutesAvailability.samples || !samplesRoutesAvailability.sampleReception) {
        return null;
    }

    const getItemPath = (menuItemPath: string) => {
        return '/samples' + menuItemPath.replace('/*', '');
    };

    const isActive = pathname.startsWith(getItemPath(samplesRouteSettings.sampleReception.path));

    return (
        <SidebarMenuItem>
            <SidebarMenuButton tooltip='Sample Reception' isActive={isActive} onClick={() => navigate.toSampleReception()}>
                <PackageOpenIcon />
                <span>Sample reception</span>
            </SidebarMenuButton>
        </SidebarMenuItem>
    );
};

export default SampleReceptionMenu;
